/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Group_HistoryInputs */

const en_us2_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workouts`)
};

const pt_br2_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus treinos`)
};

const es_419_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus entrenamientos`)
};

const pt_pt2_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus treinos`)
};

const fr_fr2_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes séances`)
};

const de_de2_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Trainings`)
};

const it_it2_search_group_history = /** @type {(inputs: Search_Group_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi allenamenti`)
};

/**
* | output |
* | --- |
* | "Your workouts" |
*
* @param {Search_Group_HistoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_group_history = /** @type {((inputs?: Search_Group_HistoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Group_HistoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_group_history(inputs)
	if (locale === "es-419") return es_419_search_group_history(inputs)
	if (locale === "pt-PT") return pt_pt2_search_group_history(inputs)
	if (locale === "fr-FR") return fr_fr2_search_group_history(inputs)
	if (locale === "de-DE") return de_de2_search_group_history(inputs)
	if (locale === "it-IT") return it_it2_search_group_history(inputs)
	return en_us2_search_group_history(inputs)
});
export { search_group_history as "search.group_history" }